export function formatMoney(amountMinor: number, currency: string) {
  const value = amountMinor / 100;
  const hasDecimals = amountMinor % 100 !== 0;

  const parts = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: hasDecimals ? 2 : 0,
    maximumFractionDigits: hasDecimals ? 2 : 0,
  }).formatToParts(value);

  const literal = parts.find((p) => p.type === "currency");
  const rest = parts.filter(
    (p) => p.type !== "currency" && p.type !== "literal",
  );

  return rest.map((p) => p.value).join("") + literal?.value;
}
